import Admin2 from "layouts/Admin2";
import React from "react";
import { useLocation } from 'react-router-dom';
import PageHeading from 'admin/components/PageHeading';
import { portalPageMeta } from 'layouts/Admin2/pageMeta';
import PortalSkeleton from 'components/PortalLoading';
import { portalLoadingLayout } from 'components/PortalLoading/pageLayouts';

const AdminPageLoader = () => {
	const { pathname } = useLocation();
	const meta = portalPageMeta(pathname);
	return (
		<Admin2 fullWidth>
			<PageHeading title={meta.title} description={meta.description} />
			<PortalSkeleton {...portalLoadingLayout(pathname)} label={`Loading ${meta.title.toLowerCase()}…`} />
		</Admin2>
	);
};

export default AdminPageLoader;
